import React, { CSSProperties, Fragment, ReactNode, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { primaryColor } from "../colors";
import { primaryGradient } from "../GradientBox";
import { translation } from "../translations";
import {
  careersUrl,
  FacebookIcon,
  facebookPageUrl,
  LogoIcon,
  NavigationPath,
  stripSlash,
} from "./NavigationCommon";

const height = 60;

const makeIconStyle = (
  imageUrl: string,
  height: number = 42,
  width: number = 42,
) => ({
  display: "block",
  height: height,
  width: width,
  backgroundImage: `url(${imageUrl})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "contain",
});

export const MobileNavigation: React.FC = () => {
  const { pathname } = useLocation();
  const [isExpanded, setExpanded] = useState(false);

  const linkStyle: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: height,
    textDecoration: "none",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: primaryColor,
  };

  const buildInternalLink = (to: NavigationPath, text: string) => {
    const isActive = stripSlash(pathname) === to;
    return (
      <Link
        to={to}
        style={{
          ...linkStyle,
          color: isActive ? "white" : primaryColor,
          background: isActive ? primaryGradient : undefined,
        }}
      >
        {text}
      </Link>
    );
  };

  // TODO: Use <ExternalLink> instead
  const buildExternalLink = (href: string, text: ReactNode) => {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        style={linkStyle}
      >
        {text}
      </a>
    );
  };

  const buildButton = (imageUrl: string, onClick?: () => void) => {
    return (
      <button
        style={{
          margin: 0,
          padding: 0,
          verticalAlign: "top",
          backgroundColor: "transparent",
          border: "none",
          ...makeIconStyle(imageUrl),
        }}
        onClick={onClick}
      />
    );
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 16,
          paddingRight: 16,
          height: height,
          position: "relative",
        }}
      >
        <Link to={NavigationPath.home}>
          <LogoIcon />
        </Link>
        {buildButton(
          isExpanded ? "/home/cross.svg" : "/home/hamburger.svg",
          () => setExpanded(!isExpanded),
        )}
      </div>
      {isExpanded && (
        <nav
          style={{
            position: "absolute",
            top: height,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
            width: "100%",
            zIndex: 100,
          }}
        >
          {buildInternalLink(NavigationPath.insurers, translation.navInsurers)}
          {buildInternalLink(
            NavigationPath.biologicalAge,
            `${translation.navBiologicalAgeTitle} ${translation.navBiologicalAgeSubtitle}`,
          )}
          {buildInternalLink(NavigationPath.team, translation.navTeam)}
          {buildExternalLink(careersUrl, translation.navCareers)}
          {buildExternalLink(
            facebookPageUrl,
            <Fragment>
              {translation.navFacebook}
              <FacebookIcon />
            </Fragment>,
          )}
        </nav>
      )}
    </div>
  );
};
